module.exports = __webpack_public_path__ + "img/daishenhe.65349f15.png";